import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { MessageSquare, X, ChevronRight } from "lucide-react";

import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setConvo, updateMessage } from "../Redux/Actions/convoActions";
import { 
  getValidChatSession, 
  saveChatSession, 
  clearChatSession,
  getValidDexySession, 
  clearDexySession,
  getKnownRooms, 
  addKnownRoom, 
  addUnreadThread, 
  getUnreadThreads, 
  clearUnreadThread 
} from "../utils/sessionManager";
import { getSocket } from "../utils/useChatSocket";
import { getAgentInfoById, getCachedAgentInfo } from "../utils/agentService";
import { kbService } from "../utils/kbService";

import Draggable from "react-draggable";

import axios from "axios";

import { CSSTransition, SwitchTransition } from "react-transition-group";

import "../CSS/CustomerChat.css";
import "../CSS/Transitions.css";
import useContinuousTokenChecking from "../utils/continuousTokenChecking";

import AIAgentInfo from "./AIAgentInfo";
import Auth from "./Auth";
import CDAInfo from "./CDAInfo";
import ChatList from "./ChatList";
import Convo from "./Convo";
import DexKor from "./DexKor";
import DexKorOverview from "./DexKorOverview";
import Footer from "./Footer";
import Header from "./Header";
import Help from "./Help";
import LandingWindow from "./LandingWindow";
import LiveChat from "./LiveChat";
import Message from "./Message";
import MessageDetails from "./MessageDetails";
import MetricsAndAttributes from "./MetricsAndAttributes";
import SupportContent from "./SupportContent";
import AutomatedBot from "./automatedBot";
import DexyAi from "./DexyAi";
import News from "./News";
import Roadmap from "./Roadmap";
import SurveyWidgetModal from "./SurveyWidgetModal";
import { surveyWidgetService } from "../utils/surveyWidgetService";
// const socket = getSocket();
import notificationSound from "../assets/notification.wav";
// Get initial token from localStorage
const initialToken = localStorage.getItem("dexkor-chat-widget-auth-token");
const socket = getSocket(initialToken);

const ChatWindow = (rawProps = {}) => {
  const resolvedEmail = rawProps?.userEmail || rawProps?.email;
  const props = useMemo(() => ({
    ...rawProps,
    ...(resolvedEmail ? { userEmail: resolvedEmail, email: resolvedEmail } : {})
  }), [rawProps?.uniquePartnerId, resolvedEmail, rawProps?.userId, rawProps?.hostUrl, rawProps?.userName]);
  const dispatch = useDispatch();
  const [setupDetails, SetSetupDetails] = useState(null);
  const hasFetchedSetupRef = useRef(null);
  const [message, setMessage] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  // Public host-page event: window.dispatchEvent(new Event("dexkor:open-chat"))
  useEffect(() => {
    const handleOpenChat = () => {
      setIsOpen(true);
      setView("chatList");
    };

    window.addEventListener("dexkor:open-chat", handleOpenChat);
    return () => window.removeEventListener("dexkor:open-chat", handleOpenChat);
  }, []);

  // Restore 24-hour chat session if active, matching current workflow, and not yet resolved/closed
  useEffect(() => {
    if (props?.uniquePartnerId && setupDetails) {
      const currentWorkflowId = setupDetails?.widgetWorkflow?.workflowId || "legacy";
      const activeSession = getValidChatSession(props.uniquePartnerId, currentWorkflowId);
      if (activeSession && activeSession.conversation) {
        // Don't restore a session whose ticket is already resolved or closed
        const ticketStatus = activeSession.conversation?.ticketId?.status?.toLowerCase() || "";
        if (ticketStatus === "resolved" || ticketStatus === "closed") {
          clearChatSession(props.uniquePartnerId);
          clearDexySession(props.uniquePartnerId);
          dispatch(setConvo({}));
        } else {
          dispatch(setConvo(activeSession.conversation));
        }
      } else {
        dispatch(setConvo({}));
      }
    }
  }, [props?.uniquePartnerId, setupDetails, dispatch]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [attachmentType, setAttachmentType] = useState(null);
  const [view, setView] = useState("chatList");
  // const [view, setView] = useState("LandingWindow");
  const [showTicketForm, setShowTicketForm] = useState(false);
  const [token, setToken] = useState(null);
  const [customerDetails, setCustomerDetails] = useState({
    createdAt: "",
    email: "",
    status: "",
    updatedAt: "",
    _id: "",
  });
  const [formAttchment, setFormAttachment] = useState(null);
  const [ticketId, setTicketId] = useState(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const isDragging = useRef(false);
  const clickStartTime = useRef(null);
  const dragStartPos = useRef({ x: 0, y: 0 });
  const hasDragged = useRef(false);
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [defaultMessagesData, setDefaultMessagesData] = useState(null);
  const [distanceMoved, setDistanceMoved] = useState("");
  const [activeIcon, setActiveIcon] = useState("tickets");
  // const [activeIcon, setActiveIcon] = useState("home");
  const [isAnimating, setIsAnimating] = useState(false);
  const [initialDexyMessage, setInitialDexyMessage] = useState("");
  const [selectedDexyRoomId, setSelectedDexyRoomId] = useState(null);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const convo = useSelector((state) => state.convo);

  // Real-time widget presence tracking
  useEffect(() => {
    const convoId = convo?._id || convo?.convoId;
    const ticketId = typeof convo?.ticketId === 'object' ? convo?.ticketId?._id : convo?.ticketId;
    const roomId = convo?.roomId;

    if ((convoId || ticketId || roomId) && socket) {
      const payload = { convoId, ticketId, roomId, isOnline: true };
      socket.emit("widget:presence", payload);

      const handleUnload = () => {
        try {
          socket.emit("widget:presence", { ...payload, isOnline: false });
        } catch (e) {}
      };

      window.addEventListener("beforeunload", handleUnload);
      window.addEventListener("pagehide", handleUnload);

      return () => {
        window.removeEventListener("beforeunload", handleUnload);
        window.removeEventListener("pagehide", handleUnload);
        try {
          socket.emit("widget:presence", { ...payload, isOnline: false });
        } catch (e) {}
      };
    }
  }, [convo?._id, convo?.convoId, convo?.ticketId, convo?.roomId]);
  const [unreadNotifications, setUnreadNotifications] = useState(() => {
    try {
      const saved = localStorage.getItem("dexkor-chat-widget-unread-notifications");
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  const [showNotificationPopup, setShowNotificationPopup] = useState(() => {
    try {
      const savedNotifs = localStorage.getItem("dexkor-chat-widget-unread-notifications");
      const parsedNotifs = savedNotifs ? JSON.parse(savedNotifs) : [];
      if (!parsedNotifs || parsedNotifs.length === 0) return false;
      const savedPopup = localStorage.getItem("dexkor-chat-widget-show-notification-popup");
      return savedPopup !== null ? JSON.parse(savedPopup) : true;
    } catch (e) {
      return false;
    }
  });

  const [tabUnreadCounts, setTabUnreadCounts] = useState(() => {
    try {
      const saved = localStorage.getItem("dexkor-chat-widget-tab-unread-counts");
      return saved ? JSON.parse(saved) : { tickets: 0, messages: 0, ai: 0 };
    } catch (e) {
      return { tickets: 0, messages: 0, ai: 0 };
    }
  });

  // News In-App Pop-up State & Handlers
  const [activeNewsPopup, setActiveNewsPopup] = useState(null);
  const reshowTimerRef = useRef(null);
  const popupDisplayTimerRef = useRef(null);

  const isPopupDismissed = useCallback((articleId, popupConfig) => {
    try {
      const artIdStr = String(articleId);
      const reshowCfg = popupConfig?.reshowAfterDismiss;

      // Check timestamp map
      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_popup_dismissal_timestamps") || "{}"
      );
      const dismissedTime = timestampMap[artIdStr];

      if (dismissedTime) {
        if (reshowCfg?.enabled && reshowCfg?.seconds > 0) {
          const elapsedSeconds = (Date.now() - Number(dismissedTime)) / 1000;
          if (elapsedSeconds >= reshowCfg.seconds) {
            // Cooldown has passed! Show popup again
            return false;
          }
          // Cooldown active, stay dismissed
          return true;
        }
        // Permanently dismissed
        return true;
      }

      // If reshow is enabled on this popup, don't let legacy array block it
      if (reshowCfg?.enabled && reshowCfg?.seconds > 0) {
        return false;
      }

      // Check fallback array for legacy records
      const dismissedList = JSON.parse(
        localStorage.getItem("dexkor_dismissed_news_popups") || "[]"
      );
      return Array.isArray(dismissedList) && dismissedList.includes(artIdStr);
    } catch (e) {
      return false;
    }
  }, []);

  const fetchPopups = useCallback(async () => {
    try {
      const partnerId = props?.uniquePartnerId || setupDetails?.uniquePartnerId;
      if (!partnerId) return;

      const userEmail =
        props?.userEmail ||
        customerDetails?.email ||
        localStorage.getItem("dexkor_customer_email") ||
        localStorage.getItem("dexkor_voter_email") ||
        "";
      const currentUrl = typeof window !== "undefined" ? window.location.href : "";

      const popups = await kbService.getActivePopups(partnerId, {
        email: userEmail,
        url: currentUrl,
      });

      if (!Array.isArray(popups) || popups.length === 0) return;

      let nextCooldownRemainingMs = null;

      const eligible = popups.find((p) => {
        const artId = p.articleId || p._id;
        const reshowCfg = p.popupConfig?.reshowAfterDismiss;
        const dismissed = isPopupDismissed(artId, p.popupConfig);

        if (dismissed && reshowCfg?.enabled && reshowCfg?.seconds > 0) {
          const timestampMap = JSON.parse(
            localStorage.getItem("dexkor_popup_dismissal_timestamps") || "{}"
          );
          const dismissedTime = timestampMap[String(artId)];
          if (dismissedTime) {
            const elapsedSec = (Date.now() - Number(dismissedTime)) / 1000;
            const remainingSec = reshowCfg.seconds - elapsedSec;
            if (remainingSec > 0) {
              const remMs = remainingSec * 1000;
              if (nextCooldownRemainingMs === null || remMs < nextCooldownRemainingMs) {
                nextCooldownRemainingMs = remMs;
              }
            }
          }
        }

        return !dismissed;
      });

      // If a popup is still in dismissal cooldown, schedule automatic re-check
      if (nextCooldownRemainingMs !== null && nextCooldownRemainingMs > 0) {
        if (reshowTimerRef.current) clearTimeout(reshowTimerRef.current);
        reshowTimerRef.current = setTimeout(() => {
          fetchPopups();
        }, nextCooldownRemainingMs);
      }

      if (!eligible) return;

      const triggerDelay =
        eligible.popupConfig?.trigger?.timing === "after_delay"
          ? (eligible.popupConfig?.trigger?.delaySeconds || 5)
          : (eligible.popupConfig?.pageRules?.timeOnPageSeconds || 0);

      if (triggerDelay > 0) {
        popupDisplayTimerRef.current = setTimeout(() => {
          setActiveNewsPopup(eligible);
          kbService.trackPopupInteraction(eligible.articleId || eligible._id, "impression");
        }, triggerDelay * 1000);
      } else {
        setActiveNewsPopup(eligible);
        kbService.trackPopupInteraction(eligible.articleId || eligible._id, "impression");
      }
    } catch (err) {
      console.error("Error fetching active popups:", err);
    }
  }, [props?.uniquePartnerId, setupDetails?.uniquePartnerId, props?.userEmail, customerDetails?.email, isPopupDismissed]);

  const handleDismissNewsPopup = useCallback((articleId, e) => {
    if (e) e.stopPropagation();
    const userEmail =
      props?.userEmail ||
      customerDetails?.email ||
      localStorage.getItem("dexkor_customer_email") ||
      localStorage.getItem("dexkor_voter_email") ||
      "";

    const currentPopup = activeNewsPopup;
    const reshowCfg = currentPopup?.popupConfig?.reshowAfterDismiss;

    try {
      const artIdStr = String(articleId);
      // Record timestamp for reshow cooldown
      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_popup_dismissal_timestamps") || "{}"
      );
      timestampMap[artIdStr] = Date.now();
      localStorage.setItem("dexkor_popup_dismissal_timestamps", JSON.stringify(timestampMap));

      // Record in legacy array ONLY if reshow is NOT enabled
      if (!reshowCfg?.enabled) {
        const dismissed = JSON.parse(localStorage.getItem("dexkor_dismissed_news_popups") || "[]");
        if (!dismissed.includes(artIdStr)) {
          dismissed.push(artIdStr);
          localStorage.setItem("dexkor_dismissed_news_popups", JSON.stringify(dismissed));
        }
      } else {
        // If reshow is enabled, remove from legacy array so it doesn't block re-showing
        const dismissed = JSON.parse(localStorage.getItem("dexkor_dismissed_news_popups") || "[]");
        if (dismissed.includes(artIdStr)) {
          const updated = dismissed.filter(id => id !== artIdStr);
          localStorage.setItem("dexkor_dismissed_news_popups", JSON.stringify(updated));
        }
      }
    } catch (err) {
      console.error("Error storing dismissed popup:", err);
    }

    setActiveNewsPopup(null);

    // Schedule re-show if reshowAfterDismiss is enabled!
    if (reshowCfg?.enabled && reshowCfg?.seconds > 0) {
      if (reshowTimerRef.current) clearTimeout(reshowTimerRef.current);
      reshowTimerRef.current = setTimeout(() => {
        fetchPopups();
      }, reshowCfg.seconds * 1000);
    }

    if (articleId) {
      kbService.trackPopupInteraction(articleId, "dismissal", userEmail);
    }
  }, [activeNewsPopup, fetchPopups, props?.userEmail, customerDetails?.email]);

  const handleOpenNewsPopup = useCallback((popup, e) => {
    if (e) e.stopPropagation();
    const userEmail =
      props?.userEmail ||
      customerDetails?.email ||
      localStorage.getItem("dexkor_customer_email") ||
      localStorage.getItem("dexkor_voter_email") ||
      "";
    const artId = popup.articleId || popup._id;
    if (artId) {
      kbService.trackPopupInteraction(artId, "click", userEmail);

      // Record read/dismissal state in localStorage so it does not pop up again!
      try {
        const artIdStr = String(artId);
        const reshowCfg = popup?.popupConfig?.reshowAfterDismiss;
        const timestampMap = JSON.parse(
          localStorage.getItem("dexkor_popup_dismissal_timestamps") || "{}"
        );
        timestampMap[artIdStr] = Date.now();
        localStorage.setItem("dexkor_popup_dismissal_timestamps", JSON.stringify(timestampMap));

        if (!reshowCfg?.enabled) {
          const dismissed = JSON.parse(localStorage.getItem("dexkor_dismissed_news_popups") || "[]");
          if (!dismissed.includes(artIdStr)) {
            dismissed.push(artIdStr);
            localStorage.setItem("dexkor_dismissed_news_popups", JSON.stringify(dismissed));
          }
        }
      } catch (err) {
        console.error("Error storing read popup state:", err);
      }
    }
    setSelectedArticle(popup);
    setActiveIcon("news");
    setView("News");
    setIsOpen(true);
    setActiveNewsPopup(null);
  }, [props?.userEmail, customerDetails?.email]);

  // Fetch active in-app popups for news on mount
  useEffect(() => {
    fetchPopups();

    return () => {
      if (reshowTimerRef.current) clearTimeout(reshowTimerRef.current);
      if (popupDisplayTimerRef.current) clearTimeout(popupDisplayTimerRef.current);
    };
  }, [fetchPopups]);

  // Whenever an article is opened to read, record its read state so it does not pop up again!
  useEffect(() => {
    if (selectedArticle) {
      const artId = selectedArticle._id || selectedArticle.id || selectedArticle.articleId;
      if (artId) {
        try {
          const artIdStr = String(artId);
          const timestampMap = JSON.parse(
            localStorage.getItem("dexkor_popup_dismissal_timestamps") || "{}"
          );
          timestampMap[artIdStr] = Date.now();
          localStorage.setItem("dexkor_popup_dismissal_timestamps", JSON.stringify(timestampMap));

          const reshowCfg = selectedArticle?.popupConfig?.reshowAfterDismiss;
          if (!reshowCfg?.enabled) {
            const dismissed = JSON.parse(
              localStorage.getItem("dexkor_dismissed_news_popups") || "[]"
            );
            if (!dismissed.includes(artIdStr)) {
              dismissed.push(artIdStr);
              localStorage.setItem("dexkor_dismissed_news_popups", JSON.stringify(dismissed));
            }
          }
        } catch (e) {
          console.error("Error saving read article state:", e);
        }
      }
    }
  }, [selectedArticle]);

  // Survey In-App Pop-up State & Handlers
  const [activeSurveyPopup, setActiveSurveyPopup] = useState(null);
  const surveyReshowTimerRef = useRef(null);
  const surveyDisplayTimerRef = useRef(null);

  const isSurveyDismissed = useCallback((surveyId, reshowCfg) => {
    try {
      const sIdStr = String(surveyId);
      const isCompleted = localStorage.getItem(`dexkor_survey_completed_${sIdStr}`);
      if (isCompleted === "true") return true;

      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_survey_dismissal_timestamps") || "{}"
      );
      const dismissedTime = timestampMap[sIdStr];

      if (dismissedTime) {
        if (reshowCfg?.enabled) {
          const value = Number(reshowCfg?.value || 1);
          const unit = reshowCfg?.unit || "days";
          let cooldownMs = value * 24 * 3600 * 1000;
          if (unit === "seconds") cooldownMs = value * 1000;
          else if (unit === "minutes") cooldownMs = value * 60 * 1000;
          else if (unit === "hours") cooldownMs = value * 3600 * 1000;

          const elapsedMs = Date.now() - Number(dismissedTime);
          if (elapsedMs >= cooldownMs) {
            return false;
          }
          return true;
        }
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }, []);

  const fetchActiveSurveys = useCallback(async () => {
    try {
      const partnerId = props?.uniquePartnerId || setupDetails?.uniquePartnerId;
      if (!partnerId) return;

      const userEmail =
        props?.userEmail ||
        customerDetails?.email ||
        localStorage.getItem("dexkor_customer_email") ||
        localStorage.getItem("dexkor_voter_email") ||
        "";
      const currentUrl = typeof window !== "undefined" ? window.location.href : "";

      const surveys = await surveyWidgetService.getActiveSurveys(partnerId);
      if (!Array.isArray(surveys) || surveys.length === 0) {
        console.log("[DexKor Survey] No active surveys found for partner:", partnerId);
        return;
      }

      let nextCooldownRemainingMs = null;
      let selectedSurvey = null;

      const checkUrlMatch = (rule, urlStr) => {
        if (!rule) return false;
        const target = typeof rule === 'object' ? rule?.url : rule;
        const operator = typeof rule === 'object' ? (rule?.operator || 'contains') : 'contains';
        if (!target) return false;

        const cleanCurrent = (urlStr || '').toLowerCase();
        const cleanTarget = (target || '').toLowerCase();

        if (operator === 'equals') return cleanCurrent === cleanTarget || cleanCurrent === cleanTarget + '/';
        if (operator === 'starts_with') return cleanCurrent.startsWith(cleanTarget);
        if (operator === 'ends_with') return cleanCurrent.endsWith(cleanTarget);
        return cleanCurrent.includes(cleanTarget);
      };

      for (const survey of surveys) {
        const surveyId = survey._id;
        const shareConfig = survey.shareConfig || {};
        const reshowCfg = shareConfig.reshowAfterDismiss;
        const pageRules = shareConfig.pageRules || {};
        const stopSending = shareConfig.stopSending || {};
        const frequency = shareConfig.frequency;

        // 1. Check Stop Sending Custom Date
        if (stopSending.type === 'custom_date' && stopSending.customDate) {
          if (new Date() > new Date(stopSending.customDate)) {
            console.log(`[DexKor Survey] Survey "${survey.name}" skipped: stop sending date passed (${stopSending.customDate})`);
            continue;
          }
        }

        // 2. Check Frequency (once_per_session)
        if (frequency === 'once_per_session') {
          const sessionSeen = sessionStorage.getItem(`dexkor_survey_seen_${surveyId}`);
          if (sessionSeen === "true") {
            console.log(`[DexKor Survey] Survey "${survey.name}" skipped: once per session limit`);
            continue;
          }
        }

        // 3. Page rules matching (includePages / excludePages with operators)
        if (pageRules.includePages && pageRules.includePages.length > 0) {
          const match = pageRules.includePages.some((rule) => checkUrlMatch(rule, currentUrl));
          if (!match) {
            console.log(`[DexKor Survey] Survey "${survey.name}" skipped: includePages URL mismatch`);
            continue;
          }
        }

        if (pageRules.excludePages && pageRules.excludePages.length > 0) {
          const excludeMatch = pageRules.excludePages.some((rule) => checkUrlMatch(rule, currentUrl));
          if (excludeMatch) {
            console.log(`[DexKor Survey] Survey "${survey.name}" skipped: excludePages URL match`);
            continue;
          }
        }

        // 4. Dismissal & Cooldown check
        const dismissed = isSurveyDismissed(surveyId, reshowCfg);

        if (dismissed && reshowCfg?.enabled) {
          const timestampMap = JSON.parse(
            localStorage.getItem("dexkor_survey_dismissal_timestamps") || "{}"
          );
          const dismissedTime = timestampMap[String(surveyId)];
          if (dismissedTime) {
            const value = Number(reshowCfg.value || 1);
            const unit = reshowCfg.unit || "days";
            let cooldownMs = value * 24 * 3600 * 1000;
            if (unit === "seconds") cooldownMs = value * 1000;
            else if (unit === "minutes") cooldownMs = value * 60 * 1000;
            else if (unit === "hours") cooldownMs = value * 3600 * 1000;

            const elapsedMs = Date.now() - Number(dismissedTime);
            const remainingMs = cooldownMs - elapsedMs;
            if (remainingMs > 0) {
              if (nextCooldownRemainingMs === null || remainingMs < nextCooldownRemainingMs) {
                nextCooldownRemainingMs = remainingMs;
              }
            }
          }
        }

        if (dismissed) {
          console.log(`[DexKor Survey] Survey "${survey.name}" (${surveyId}) skipped: dismissed/completed in localStorage`);
          continue;
        }

        // 5. Backend Email Eligibility check
        if (userEmail) {
          const eligibility = await surveyWidgetService.checkEligibility(surveyId, userEmail);
          if (!eligibility.shouldShow) {
            console.log(`[DexKor Survey] Survey "${survey.name}" skipped by backend eligibility:`, eligibility.reason);
            if (eligibility.reason === 'already_submitted') {
              try {
                localStorage.setItem(`dexkor_survey_completed_${surveyId}`, "true");
              } catch (e) {}
            }
            continue;
          }
        }

        selectedSurvey = survey;
        break;
      }

      if (selectedSurvey) {
        console.log(`[DexKor Survey] Triggering survey: "${selectedSurvey.name}" (${selectedSurvey._id})`);
        const shareConfig = selectedSurvey.shareConfig || {};
        const pageRules = shareConfig.pageRules || {};
        const trigger = shareConfig.trigger || {};

        let triggerDelaySec = 0;
        if (trigger.timing === 'after_delay') {
          const val = Number(trigger.delayValue || 0);
          const unit = trigger.delayUnit || 'seconds';
          if (unit === 'seconds') triggerDelaySec = val;
          else if (unit === 'minutes') triggerDelaySec = val * 60;
          else if (unit === 'hours') triggerDelaySec = val * 3600;
          else if (unit === 'days') triggerDelaySec = val * 86400;
        }

        const timeOnPageSec = Number(pageRules.timeOnPageSeconds || 0);
        const totalDelaySeconds = Math.max(triggerDelaySec, timeOnPageSec);

        if (surveyDisplayTimerRef.current) clearTimeout(surveyDisplayTimerRef.current);

        if (totalDelaySeconds > 0) {
          console.log(`[DexKor Survey] Waiting ${totalDelaySeconds}s delay before showing survey...`);
          surveyDisplayTimerRef.current = setTimeout(() => {
            setActiveSurveyPopup(selectedSurvey);
            if (selectedSurvey.shareConfig?.frequency === 'once_per_session') {
              sessionStorage.setItem(`dexkor_survey_seen_${selectedSurvey._id}`, "true");
            }
          }, totalDelaySeconds * 1000);
        } else {
          setActiveSurveyPopup(selectedSurvey);
          if (selectedSurvey.shareConfig?.frequency === 'once_per_session') {
            sessionStorage.setItem(`dexkor_survey_seen_${selectedSurvey._id}`, "true");
          }
        }
      }

      if (nextCooldownRemainingMs !== null && nextCooldownRemainingMs > 0) {
        if (surveyReshowTimerRef.current) clearTimeout(surveyReshowTimerRef.current);
        surveyReshowTimerRef.current = setTimeout(() => {
          fetchActiveSurveys();
        }, nextCooldownRemainingMs);
      }
    } catch (err) {
      console.error("Error fetching active surveys in widget:", err);
    }
  }, [props?.uniquePartnerId, setupDetails?.uniquePartnerId, props?.userEmail, customerDetails?.email, isSurveyDismissed]);

  const handleDismissSurvey = useCallback((surveyId, reshowCfg) => {
    try {
      const sIdStr = String(surveyId);
      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_survey_dismissal_timestamps") || "{}"
      );
      timestampMap[sIdStr] = Date.now();
      localStorage.setItem("dexkor_survey_dismissal_timestamps", JSON.stringify(timestampMap));
    } catch (e) {
      console.error("Error saving survey dismissal timestamp:", e);
    }

    setActiveSurveyPopup(null);

    if (reshowCfg?.enabled) {
      const value = Number(reshowCfg.value || 1);
      const unit = reshowCfg.unit || "days";
      let cooldownMs = value * 24 * 3600 * 1000;
      if (unit === "seconds") cooldownMs = value * 1000;
      else if (unit === "minutes") cooldownMs = value * 60 * 1000;
      else if (unit === "hours") cooldownMs = value * 3600 * 1000;

      if (surveyReshowTimerRef.current) clearTimeout(surveyReshowTimerRef.current);
      surveyReshowTimerRef.current = setTimeout(() => {
        fetchActiveSurveys();
      }, cooldownMs);
    }
  }, [fetchActiveSurveys]);

  // Chat Message In-App Pop-up State & Handlers
  const [activeChatMessagePopup, setActiveChatMessagePopup] = useState(null);
  const chatMessageReshowTimerRef = useRef(null);
  const chatMessageDisplayTimerRef = useRef(null);

  const isChatMessageDismissed = useCallback((msgId, reshowCfg) => {
    try {
      const idStr = String(msgId);
      const isCompleted = localStorage.getItem(`dexkor_chat_message_completed_${idStr}`);
      if (isCompleted === "true") return true;

      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_chat_message_dismissal_timestamps") || "{}"
      );
      const dismissedTime = timestampMap[idStr];

      if (dismissedTime) {
        if (reshowCfg?.howOften === "once_per_session") {
          const sessionSeen = sessionStorage.getItem(`dexkor_chat_message_seen_${idStr}`);
          if (sessionSeen === "true") return true;
        }
        if (reshowCfg?.enabled) {
          const value = Number(reshowCfg?.value || 1);
          const unit = reshowCfg?.unit || "days";
          let cooldownMs = value * 24 * 3600 * 1000;
          if (unit === "seconds") cooldownMs = value * 1000;
          else if (unit === "minutes") cooldownMs = value * 60 * 1000;
          else if (unit === "hours") cooldownMs = value * 3600 * 1000;

          const elapsedMs = Date.now() - Number(dismissedTime);
          if (elapsedMs >= cooldownMs) {
            return false;
          }
          return true;
        }
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }, []);

  const fetchActiveChatMessages = useCallback(async () => {
    try {
      const partnerId = props?.uniquePartnerId || setupDetails?.uniquePartnerId;
      if (!partnerId) return;

      const userEmail =
        props?.userEmail ||
        customerDetails?.email ||
        localStorage.getItem("dexkor_customer_email") ||
        localStorage.getItem("dexkor_voter_email") ||
        "";

      const currentUrl = typeof window !== "undefined" ? window.location.href : "";
      const list = await surveyWidgetService.getActiveChatMessages(partnerId);
      if (!Array.isArray(list) || list.length === 0) {
        console.log("[DexKor ChatMessage] No active chat messages for partner:", partnerId);
        return;
      }

      const checkUrlMatchHelper = (rule, urlStr) => {
        if (!rule) return false;
        const target = typeof rule === 'object' ? (rule?.url || rule?.value) : rule;
        const operator = typeof rule === 'object' ? (rule?.operator || 'contains') : 'contains';
        if (!target) return false;

        const cleanCurrent = (urlStr || '').toLowerCase();
        const cleanTarget = (target || '').toLowerCase();

        if (operator === 'equals') return cleanCurrent === cleanTarget || cleanCurrent === cleanTarget + '/';
        if (operator === 'starts_with') return cleanCurrent.startsWith(cleanTarget);
        if (operator === 'ends_with') return cleanCurrent.endsWith(cleanTarget);
        return cleanCurrent.includes(cleanTarget);
      };

      let selectedMessage = null;

      for (const item of list) {
        const msgId = item._id;
        const shareConfig = item.shareConfig || {};
        const pageRules = shareConfig.pages || shareConfig.pageRules || {};
        const frequency = shareConfig.frequency || {};

        if (userEmail) {
          const check = await surveyWidgetService.checkChatMessageEligibility(msgId, userEmail);
          if (check?.shouldShow === false) {
            console.log(`[DexKor ChatMessage] "${item.name}" skipped: user ${userEmail} already responded/clicked`);
            continue;
          }
        }

        if (frequency.howOften === "once_per_session") {
          const sessionSeen = sessionStorage.getItem(`dexkor_chat_message_seen_${msgId}`);
          if (sessionSeen === "true") continue;
        }

        if (pageRules.includePages && pageRules.includePages.length > 0) {
          const match = pageRules.includePages.some((rule) => checkUrlMatchHelper(rule, currentUrl));
          if (!match) continue;
        }
        if (pageRules.rules && pageRules.rules.length > 0 && pageRules.rules[0]?.value) {
          const match = pageRules.rules.some((rule) => checkUrlMatchHelper(rule, currentUrl));
          if (!match) continue;
        }
        if (pageRules.excludePages && pageRules.excludePages.length > 0) {
          const excludeMatch = pageRules.excludePages.some((rule) => checkUrlMatchHelper(rule, currentUrl));
          if (excludeMatch) continue;
        }

        const dismissed = isChatMessageDismissed(msgId, frequency);
        if (dismissed) continue;

        selectedMessage = item;
        break;
      }

      if (selectedMessage) {
        console.log(`[DexKor ChatMessage] Triggering in-app popup for: "${selectedMessage.name}"`);
        const shareConfig = selectedMessage.shareConfig || {};
        const trigger = shareConfig.trigger || {};
        let delaySec = 0;
        if (trigger.delayValue) {
          const val = Number(trigger.delayValue);
          const unit = trigger.delayUnit || 'seconds';
          if (unit === 'seconds') delaySec = val;
          else if (unit === 'minutes') delaySec = val * 60;
          else if (unit === 'hours') delaySec = val * 3600;
          else if (unit === 'days') delaySec = val * 86400;
        }

        if (chatMessageDisplayTimerRef.current) clearTimeout(chatMessageDisplayTimerRef.current);

        const displayMessage = () => {
          setActiveChatMessagePopup(selectedMessage);
          if (selectedMessage.notificationSound !== false) {
            try {
              const audio = new Audio(notificationSound);
              audio.play().catch(() => {});
            } catch (e) {}
          }
          if (selectedMessage.shareConfig?.frequency?.howOften === 'once_per_session') {
            sessionStorage.setItem(`dexkor_chat_message_seen_${selectedMessage._id}`, "true");
          }
          if (userEmail) {
            surveyWidgetService.submitChatMessageResponse(selectedMessage._id, {
              contactEmail: userEmail,
              contactName: props?.userName || customerDetails?.name || 'Anonymous',
              action: 'impression',
              url: currentUrl
            });
          }
        };

        if (delaySec > 0) {
          chatMessageDisplayTimerRef.current = setTimeout(displayMessage, delaySec * 1000);
        } else {
          displayMessage();
        }
      }
    } catch (err) {
      console.error("Error fetching active chat messages in widget:", err);
    }
  }, [props?.uniquePartnerId, props?.userEmail, props?.userName, customerDetails?.email, customerDetails?.name, setupDetails?.uniquePartnerId, isChatMessageDismissed]);

  const handleDismissChatMessage = useCallback((msgId, frequency, e) => {
    if (e) e.stopPropagation();
    try {
      const idStr = String(msgId);
      localStorage.setItem(`dexkor_chat_message_completed_${idStr}`, "true");
      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_chat_message_dismissal_timestamps") || "{}"
      );
      timestampMap[idStr] = Date.now();
      localStorage.setItem("dexkor_chat_message_dismissal_timestamps", JSON.stringify(timestampMap));
    } catch (err) {}

    const userEmail =
      props?.userEmail ||
      customerDetails?.email ||
      localStorage.getItem("dexkor_customer_email") ||
      localStorage.getItem("dexkor_voter_email") ||
      "";

    if (userEmail && msgId) {
      surveyWidgetService.submitChatMessageResponse(msgId, {
        contactEmail: userEmail,
        contactName: props?.userName || customerDetails?.name || 'Anonymous',
        action: 'dismiss',
        url: typeof window !== 'undefined' ? window.location.href : ''
      });
    }

    setActiveChatMessagePopup(null);
  }, [props?.userEmail, props?.userName, customerDetails?.email, customerDetails?.name]);

  const handleChatMessageClick = useCallback((msg) => {
    try {
      if (msg?._id) {
        localStorage.setItem(`dexkor_chat_message_completed_${msg._id}`, "true");
      }
    } catch (e) {}

    const userEmail =
      props?.userEmail ||
      customerDetails?.email ||
      localStorage.getItem("dexkor_customer_email") ||
      localStorage.getItem("dexkor_voter_email") ||
      "";

    if (userEmail && msg._id) {
      surveyWidgetService.submitChatMessageResponse(msg._id, {
        contactEmail: userEmail,
        contactName: props?.userName || customerDetails?.name || 'Anonymous',
        action: 'click',
        url: typeof window !== 'undefined' ? window.location.href : ''
      });
    }

    const onNotificationClick = msg.onNotificationClick || 'open_conversation';
    if (onNotificationClick === 'open_conversation') {
      setIsOpen(true);
      setView('chatList');
    } else if (onNotificationClick === 'open_url' && msg.shareConfig?.url) {
      window.open(msg.shareConfig.url, '_blank');
    }
    handleDismissChatMessage(msg._id, msg.shareConfig?.frequency);
  }, [props?.userEmail, props?.userName, customerDetails?.email, customerDetails?.name, handleDismissChatMessage]);

  const renderChatMessagePopup = () => {
    if (!activeChatMessagePopup || isOpen) return null;
    const msg = activeChatMessagePopup;
    const senderName = msg.sender?.name || 'Admin';
    const senderAvatar = msg.sender?.avatar || '';
    const initial = senderName.charAt(0).toUpperCase();
    const alignment = setupDetails?.widgetCustomizations?.alignment || "right";

    return (
      <div
        onClick={() => handleChatMessageClick(msg)}
        className={`nodrag absolute bottom-16 ${alignment === "left" ? "left-0" : "right-0"} mb-2 w-[330px] bg-white rounded-2xl p-4 shadow-2xl border border-gray-100 flex flex-col gap-2 z-50 cursor-pointer animate-fade-in hover:shadow-2xl transition-all`}
      >
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3 min-w-0">
            {senderAvatar ? (
              <img
                src={senderAvatar}
                alt={senderName}
                className="w-9 h-9 rounded-full object-cover shrink-0 shadow-xs border border-gray-200"
              />
            ) : (
              <div className="w-9 h-9 rounded-full bg-blue-600 text-white font-semibold text-[13px] flex items-center justify-center shrink-0 shadow-xs">
                {initial}
              </div>
            )}
            <div className="space-y-0.5 min-w-0">
              <div className="text-[13px] font-semibold text-gray-900 leading-tight truncate">{senderName}</div>
              <div className="text-[13px] text-gray-700 leading-relaxed font-normal break-words line-clamp-3">
                {msg.message || ''}
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={(e) => handleDismissChatMessage(msg._id, msg.shareConfig?.frequency, e)}
            className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors shrink-0 cursor-pointer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  };

  // Banner In-App Announcement State & Handlers
  const [activeBannerPopup, setActiveBannerPopup] = useState(null);
  const bannerReshowTimerRef = useRef(null);
    const bannerDisplayTimerRef = useRef(null);

  const hideLauncher = props?.launcherMode === "hide";

  const isBannerDismissed = useCallback((bannerId, reshowCfg) => {
    try {
      const idStr = String(bannerId);
      const isCompleted = localStorage.getItem(`dexkor_banner_completed_${idStr}`);
      if (isCompleted === "true") return true;

      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_banner_dismissal_timestamps") || "{}"
      );
      const dismissedTime = timestampMap[idStr];

      if (dismissedTime) {
        if (reshowCfg?.howOften === "once_per_session") {
          const sessionSeen = sessionStorage.getItem(`dexkor_banner_seen_${idStr}`);
          if (sessionSeen === "true") return true;
        }
        if (reshowCfg?.enabled) {
          const value = Number(reshowCfg?.value || 1);
          const unit = reshowCfg?.unit || "days";
          let cooldownMs = value * 24 * 3600 * 1000;
          if (unit === "seconds") cooldownMs = value * 1000;
          else if (unit === "minutes") cooldownMs = value * 60 * 1000;
          else if (unit === "hours") cooldownMs = value * 3600 * 1000;

          const elapsedMs = Date.now() - Number(dismissedTime);
          if (elapsedMs >= cooldownMs) {
            return false;
          }
          return true;
        }
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }, []);

  const fetchActiveBanners = useCallback(async () => {
    try {
      const partnerId = props?.uniquePartnerId || setupDetails?.uniquePartnerId;
      if (!partnerId) return;

      const userEmail =
        props?.userEmail ||
        customerDetails?.email ||
        localStorage.getItem("dexkor_customer_email") ||
        localStorage.getItem("dexkor_voter_email") ||
        "";

      const currentUrl = typeof window !== "undefined" ? window.location.href : "";
      const list = await surveyWidgetService.getActiveBanners(partnerId);
      if (!Array.isArray(list) || list.length === 0) {
        console.log("[DexKor Banner] No active banners for partner:", partnerId);
        return;
      }

      const checkUrlMatchHelper = (rule, urlStr) => {
        if (!rule) return false;
        const target = typeof rule === 'object' ? (rule?.url || rule?.value) : rule;
        const operator = typeof rule === 'object' ? (rule?.operator || 'contains') : 'contains';
        if (!target) return false;

        const cleanCurrent = (urlStr || '').toLowerCase();
        const cleanTarget = (target || '').toLowerCase();

        if (operator === 'equals') return cleanCurrent === cleanTarget || cleanCurrent === cleanTarget + '/';
        if (operator === 'starts_with') return cleanCurrent.startsWith(cleanTarget);
        if (operator === 'ends_with') return cleanCurrent.endsWith(cleanTarget);
        return cleanCurrent.includes(cleanTarget);
      };

      let selectedBanner = null;

      for (const item of list) {
        const bId = item._id;
        const shareConfig = item.shareConfig || {};
        const pageRules = shareConfig.pages || shareConfig.pageRules || {};
        const frequency = shareConfig.frequency || {};

        if (userEmail) {
          const check = await surveyWidgetService.checkBannerEligibility(bId, userEmail);
          if (check?.shouldShow === false) {
            console.log(`[DexKor Banner] "${item.name}" skipped: user ${userEmail} already responded/clicked`);
            continue;
          }
        }

        if (frequency.howOften === "once_per_session") {
          const sessionSeen = sessionStorage.getItem(`dexkor_banner_seen_${bId}`);
          if (sessionSeen === "true") continue;
        }

        if (pageRules.includePages && pageRules.includePages.length > 0) {
          const match = pageRules.includePages.some((rule) => checkUrlMatchHelper(rule, currentUrl));
          if (!match) continue;
        }
        if (pageRules.rules && pageRules.rules.length > 0 && pageRules.rules[0]?.value) {
          const match = pageRules.rules.some((rule) => checkUrlMatchHelper(rule, currentUrl));
          if (!match) continue;
        }
        if (pageRules.excludePages && pageRules.excludePages.length > 0) {
          const excludeMatch = pageRules.excludePages.some((rule) => checkUrlMatchHelper(rule, currentUrl));
          if (excludeMatch) continue;
        }

        const dismissed = isBannerDismissed(bId, frequency);
        if (dismissed) continue;

        selectedBanner = item;
        break;
      }

      if (selectedBanner) {
        console.log(`[DexKor Banner] Triggering banner for: "${selectedBanner.name}"`);
        const shareConfig = selectedBanner.shareConfig || {};
        const trigger = shareConfig.trigger || {};
        let delaySec = 0;
        if (trigger.delayValue) {
          const val = Number(trigger.delayValue);
          const unit = trigger.delayUnit || 'seconds';
          if (unit === 'seconds') delaySec = val;
          else if (unit === 'minutes') delaySec = val * 60;
          else if (unit === 'hours') delaySec = val * 3600;
          else if (unit === 'days') delaySec = val * 86400;
        }

        if (bannerDisplayTimerRef.current) clearTimeout(bannerDisplayTimerRef.current);

        const displayBanner = () => {
          setActiveBannerPopup(selectedBanner);
          if (selectedBanner.shareConfig?.frequency?.howOften === 'once_per_session') {
            sessionStorage.setItem(`dexkor_banner_seen_${selectedBanner._id}`, "true");
          }
          if (userEmail) {
            surveyWidgetService.submitBannerResponse(selectedBanner._id, {
              contactEmail: userEmail,
              contactName: props?.userName || customerDetails?.name || 'Anonymous',
              action: 'impression',
              url: currentUrl
            });
          }
        };

        if (delaySec > 0) {
          bannerDisplayTimerRef.current = setTimeout(displayBanner, delaySec * 1000);
        } else {
          displayBanner();
        }
      }
    } catch (err) {
      console.error("Error fetching active banners in widget:", err);
    }
  }, [props?.uniquePartnerId, props?.userEmail, props?.userName, customerDetails?.email, customerDetails?.name, setupDetails?.uniquePartnerId, isBannerDismissed]);

  const handleDismissBanner = useCallback((bannerId, reshowCfg, e) => {
    if (e) e.stopPropagation();
    try {
      const bIdStr = String(bannerId);
      const timestampMap = JSON.parse(
        localStorage.getItem("dexkor_banner_dismissal_timestamps") || "{}"
      );
      timestampMap[bIdStr] = Date.now();
      localStorage.setItem("dexkor_banner_dismissal_timestamps", JSON.stringify(timestampMap));

      const userEmail =
        props?.userEmail ||
        customerDetails?.email ||
        localStorage.getItem("dexkor_customer_email") ||
        localStorage.getItem("dexkor_voter_email") ||
        "";
      if (userEmail) {
        surveyWidgetService.submitBannerResponse(bannerId, {
          contactEmail: userEmail,
          contactName: props?.userName || customerDetails?.name || 'Anonymous',
          action: 'dismiss',
          url: typeof window !== "undefined" ? window.location.href : ""
        });
      }
    } catch (err) {
      console.error("Error storing dismissed banner state:", err);
    }

    setActiveBannerPopup(null);
  }, [props?.userEmail, props?.userName, customerDetails?.email, customerDetails?.name]);

  const handleBannerActionClick = useCallback((banner, e) => {
    if (e) e.stopPropagation();
    const actionConfig = banner.actionConfig || {};
    const action = actionConfig.action || 'start_conversation';

    if (action === 'open_url' || action === 'open_link' || (actionConfig.url && action !== 'start_conversation')) {
      if (actionConfig.url) {
        let targetUrl = actionConfig.url;
        if (!targetUrl.startsWith('http://') && !targetUrl.startsWith('https://')) {
          targetUrl = 'https://' + targetUrl;
        }
        const openTarget = actionConfig.openInNewTab !== false ? '_blank' : '_self';
        window.open(targetUrl, openTarget);
      }
    } else if (action === 'start_conversation') {
      setIsOpen(true);
      setView('chatList');
    } else if (action === 'show_news_item') {
      setActiveIcon('news');
      setView('News');
      setIsOpen(true);
    } else if (action === 'show_help_article') {
      setActiveIcon('help');
      setView('Help');
      setIsOpen(true);
    } else {
      setIsOpen(true);
      setView('chatList');
    }

    const userEmail =
      props?.userEmail ||
      customerDetails?.email ||
      localStorage.getItem("dexkor_customer_email") ||
      localStorage.getItem("dexkor_voter_email") ||
      "";

    if (userEmail) {
      surveyWidgetService.submitBannerResponse(banner._id, {
        contactEmail: userEmail,
        contactName: props?.userName || customerDetails?.name || 'Anonymous',
        action: 'click',
        actionTitle: actionConfig.actionTitle || 'Action',
        url: typeof window !== "undefined" ? window.location.href : ""
      });
      localStorage.setItem(`dexkor_banner_completed_${banner._id}`, "true");
    }

    handleDismissBanner(banner._id, banner.shareConfig?.frequency);
  }, [props?.userEmail, props?.userName, customerDetails?.email, customerDetails?.name, handleDismissBanner]);

  const getBannerTextColor = (hexColor) => {
    if (!hexColor) return '#111827';
    let hex = hexColor.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
    if (hex.length !== 6) return '#111827';
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155 ? '#111827' : '#ffffff';
  };

  const renderBannerPopup = () => {
    if (!activeBannerPopup) return null;
    const banner = activeBannerPopup;
    const style = banner.style || {};
    const senderConfig = banner.senderConfig || {};
    const actionConfig = banner.actionConfig || {};

    const styleType = style.styleType || 'inline';
    const textAlignment = style.textAlignment || 'center';
    const uiColor = style.uiColor || '#F8D849';
    const textColor = getBannerTextColor(uiColor);
    const showSender = senderConfig.showSender;
    const senderName = senderConfig.sender?.name || 'Ravindra Kumar';
    const senderAvatar = senderConfig.sender?.avatar || '';
    const initial = senderName.charAt(0).toUpperCase();

    const isInline = styleType === 'inline';

    return (
      <div
        className={`dexkor-banner-container ${
          isInline
            ? 'fixed top-0 left-0 right-0 w-full z-[9999999] shadow-sm'
            : 'fixed top-4 left-1/2 -translate-x-1/2 z-[9999999] w-[92%] max-w-[850px] rounded-2xl shadow-xl border border-black/10'
        } transition-all duration-300 animate-slide-down`}
        style={{
          backgroundColor: uiColor,
          color: textColor,
        }}
      >
        <div
          className={`w-full px-4 py-3 flex items-center gap-3 text-sm font-medium ${
            textAlignment === 'left' ? 'justify-start text-left' : 'justify-center text-center'
          }`}
        >
          {/* Sender Avatar */}
          {showSender && (
            <div className="flex items-center shrink-0">
              {senderAvatar ? (
                <img
                  src={senderAvatar}
                  alt={senderName}
                  className="w-7 h-7 rounded-full object-cover border border-white/40 shadow-xs"
                />
              ) : (
                <div className="w-7 h-7 rounded-full bg-purple-600 text-white font-bold text-xs flex items-center justify-center shadow-xs border border-white/30">
                  {initial}
                </div>
              )}
            </div>
          )}

          {/* Banner Message text */}
          <div className="leading-snug break-words max-w-[80%]">
            <span dangerouslySetInnerHTML={{ __html: banner.message || 'We are currently experiencing issues with our servers.' }} />

            {/* Action Title / Link */}
            {actionConfig.actionTitle && (
              <button
                type="button"
                onClick={(e) => handleBannerActionClick(banner, e)}
                className="ml-2.5 px-3.5 py-1 bg-[#1C64F2] hover:bg-[#1552ca] text-white rounded-lg text-[13px] font-semibold transition-all shrink-0 cursor-pointer shadow-2xs inline-flex items-center"
              >
                {actionConfig.actionTitle}
              </button>
            )}
          </div>

          {/* Dismiss Close Button */}
          {senderConfig.dismissButton !== false && (
            <button
              type="button"
              onClick={(e) => handleDismissBanner(banner._id, banner.shareConfig?.frequency, e)}
              className="ml-auto p-1.5 rounded-full hover:bg-black/10 transition-colors shrink-0 cursor-pointer"
              title="Dismiss banner"
              style={{ color: textColor }}
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    );
  };

  // Fetch active surveys on mount
  useEffect(() => {
    fetchActiveSurveys();
    fetchActiveChatMessages();
    fetchActiveBanners();

    return () => {
      if (surveyReshowTimerRef.current) clearTimeout(surveyReshowTimerRef.current);
      if (surveyDisplayTimerRef.current) clearTimeout(surveyDisplayTimerRef.current);
      if (chatMessageDisplayTimerRef.current) clearTimeout(chatMessageDisplayTimerRef.current);
      if (bannerDisplayTimerRef.current) clearTimeout(bannerDisplayTimerRef.current);
      if (bannerReshowTimerRef.current) clearTimeout(bannerReshowTimerRef.current);
    };
  }, [fetchActiveSurveys, fetchActiveChatMessages, fetchActiveBanners]);

  // Real-time socket listener for live survey & chat message popups
  useEffect(() => {
    if (!socket) return;
    const handleSurveyPopup = (surveyData) => {
      console.log("📡 Received real-time survey inapp_popup:", surveyData);
      fetchActiveSurveys();
    };

    const handleChatMessagePopup = (data) => {
      console.log("📡 Received real-time chat_message inapp_popup:", data);
      fetchActiveChatMessages();
    };

    const handleBannerPopup = (data) => {
      console.log("📡 Received real-time banner inapp_popup:", data);
      fetchActiveBanners();
    };

    socket.on("survey:inapp_popup", handleSurveyPopup);
    socket.on("chat_message:inapp_popup", handleChatMessagePopup);
    socket.on("banner:inapp_popup", handleBannerPopup);

    return () => {
      socket.off("survey:inapp_popup", handleSurveyPopup);
      socket.off("chat_message:inapp_popup", handleChatMessagePopup);
      socket.off("banner:inapp_popup", handleBannerPopup);
    };
  }, [fetchActiveSurveys, fetchActiveChatMessages, fetchActiveBanners]);

  // Sync notifications to localStorage
  useEffect(() => {
    try {
      localStorage.setItem(
        "dexkor-chat-widget-unread-notifications",
        JSON.stringify(unreadNotifications),
      );
    } catch (e) {
      console.error("Error saving unread notifications:", e);
    }
  }, [unreadNotifications]);

  // Sync popup visibility state to localStorage
  useEffect(() => {
    try {
      localStorage.setItem(
        "dexkor-chat-widget-show-notification-popup",
        JSON.stringify(showNotificationPopup),
      );
    } catch (e) {
      console.error("Error saving showNotificationPopup:", e);
    }
  }, [showNotificationPopup]);

  // Sync tab unread counts to localStorage
  useEffect(() => {
    try {
      localStorage.setItem(
        "dexkor-chat-widget-tab-unread-counts",
        JSON.stringify(tabUnreadCounts),
      );
    } catch (e) {
      console.error("Error saving tabUnreadCounts:", e);
    }
  }, [tabUnreadCounts]);

  const processedMessageIdsRef = useRef(new Set());

  const cleanPreviewText = useCallback((rawHtml) => {
    if (!rawHtml) return "";
    try {
      // 1. Replace <br> and closing block tags with newline
      let processed = String(rawHtml)
        .replace(/<br\s*[/]?>/gi, "\n")
        .replace(/<\/(p|div|h[1-6]|li)>/gi, "\n")
        .replace(/<[^>]*>/g, ""); // strip remaining HTML tags

      // 2. Decode HTML entities (&nbsp;, &amp;, etc.)
      let decoded = processed;
      if (typeof DOMParser !== "undefined") {
        const doc = new DOMParser().parseFromString(processed, "text/html");
        decoded = doc.body.textContent || doc.body.innerText || "";
      } else if (typeof document !== "undefined") {
        const txt = document.createElement("textarea");
        txt.innerHTML = processed;
        decoded = txt.value;
      }

      // 3. Convert all non-breaking spaces (\u00a0 or &nbsp;) into standard spaces
      decoded = decoded.replace(/\u00a0/g, " ").replace(/&nbsp;/gi, " ");

      // 4. Collapse consecutive spaces and clean up lines
      decoded = decoded
        .split("\n")
        .map((line) => line.replace(/[ \t]+/g, " ").trim())
        .filter((line, i, arr) => line !== "" || (i > 0 && arr[i - 1] !== ""))
        .join("\n")
        .trim();

      return decoded;
    } catch (e) {
      return String(rawHtml)
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/\s+/g, " ")
        .trim();
    }
  }, []);
  // console.log(props);
  useEffect(() => {
    if (
      view === "AIAgentInfo" ||
      view === "MetricsAndAttributes" ||
      view === "CDAInfo" ||
      view === "SupportContent" ||
      view === "DexKor"
    ) {
      setIsExpanded(true);
    } else if (view !== "Help" && view !== "News") {
      setIsExpanded(false);
    }
    if (view !== "chatList") {
      setShowTicketForm(false);
    }
  }, [view]);

  // Clear tab unread count when user views that tab
  useEffect(() => {
    if (isOpen) {
      if (activeIcon === "tickets" || view === "chatList" || view === "message") {
        setTabUnreadCounts((prev) => (prev.tickets > 0 ? { ...prev, tickets: 0 } : prev));
      }
      if (
        activeIcon === "messages" ||
        activeIcon === "ai" ||
        view === "AutomatedBot" ||
        view === "DexyAI" ||
        view === "Convo"
      ) {
        setTabUnreadCounts((prev) =>
          prev.messages > 0 || prev.ai > 0
            ? { ...prev, messages: 0, ai: 0 }
            : prev
        );
        const currentActiveRoom = convo?.roomId || getValidChatSession(props.uniquePartnerId)?.roomId;
        if (currentActiveRoom) {
          clearUnreadThread(props.uniquePartnerId, currentActiveRoom);
          setUnreadNotifications((prev) => prev.filter((n) => n.room !== currentActiveRoom));
        }
      }
    }
  }, [view, activeIcon, isOpen, convo?.roomId, props.uniquePartnerId]);

  const handleAnimationEnd = () => {
    if (!isOpen) {
      setIsAnimating(false);
    }
  };

  useContinuousTokenChecking();

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("attachment", file);

    try {
      // Note: ensure your env variable matches your setup (VITE_ vs REACT_APP_)
      const response = await fetch(
        `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/attachment`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) throw new Error("Upload failed");
      const result = await response.json();
      return result; // Expected format: { data: { url, filename, type, size } }
    } catch (error) {
      console.error("Upload error:", error);
      return null;
    }
  };

  const handleStart = (e, data) => {
    isDragging.current = true;
    dragStartPos.current = { x: data.x, y: data.y };
    hasDragged.current = false;
  };

  const handleStop = (e, data) => {
    isDragging.current = false;
    const moved =
      Math.abs(data.x - dragStartPos.current.x) +
      Math.abs(data.y - dragStartPos.current.y);
    if (moved > 5) {
      hasDragged.current = true;
      setPosition({ x: data.x, y: data.y });
    }
  };

  const handleLauncherClick = (e) => {
    e.stopPropagation();
    if (hasDragged.current) {
      hasDragged.current = false;
      return;
    }
    setIsOpen((prev) => {
      const nextState = !prev;
      if (nextState) {
        setShowNotificationPopup(false);
        setUnreadNotifications([]);
        setActiveNewsPopup(null);
      }
      return nextState;
    });
  };

  useEffect(() => {
    const partnerId = props?.uniquePartnerId;
    if (!partnerId) return;
    if (hasFetchedSetupRef.current === partnerId) return;

    let isMounted = true;
    const getPartnerSetupDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/partners/setup/${partnerId}`,
        );
        if (!isMounted) return;
        hasFetchedSetupRef.current = partnerId;
        SetSetupDetails(response.data.data);
        setLoading(false);

        // Only set the initial startPage on initial load
        const cust = response.data.data?.widgetCustomizations;
        if (cust) {
          const startPage = cust.startPage || "home";
          if (startPage === "dexy" && cust.aiBot !== false) {
            setView("DexyAI");
            setActiveIcon("ai");
          } else if (startPage === "messages" && cust.conversation !== false) {
            setView("AutomatedBot");
            setActiveIcon("messages");
          } else if (startPage === "ticket" && cust.ticket !== false) {
            setView("chatList");
            setActiveIcon("tickets");
          } else if (startPage === "news" && cust.news) {
            setView("News");
            setActiveIcon("news");
          } else if (startPage === "roadmap" && cust.roadmap) {
            setView("Roadmap");
            setActiveIcon("roadmap");
          } else if (startPage === "help" && cust.help) {
            setView("Help");
            setActiveIcon("help");
          } else if (cust.home !== false) {
            setView("LandingWindow");
            setActiveIcon("home");
          } else if (cust.ticket !== false) {
            setView("chatList");
            setActiveIcon("tickets");
          }
        }
      } catch (error) {
        if (!isMounted) return;
        console.error("Error fetching setup details:", error);
        setLoading(false);
      }
    };

    getPartnerSetupDetails();
    return () => {
      isMounted = false;
    };
  }, [props?.uniquePartnerId]);

  const fetchConversations = async () => {
    // Get customerId from multiple possible sources
    const customerId = props.userId || customerDetails?._id;

    if (!customerId) {
      console.log("No customer ID available yet");
      return;
    }

    setLoading(true);
    try {
      // const customerId = customerDetails._id || props.userId;
      let url = `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/conversations/${customerId}/${props?.uniquePartnerId}`;
      // //  for  customer portal we have  fetch with customer id from props
      // let url = `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/conversations/${customerId}`;
      // if (props?.userId) {
      //   url = `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/conversations/${customerId}/${props?.uniquePartnerId}`;
      // }

      const response = await axios.get(url);
      setConversations(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching conversations:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConversations();
  }, [customerDetails, props.userId]);

  useEffect(() => {
    setToken(localStorage.getItem("dexkor-chat-widget-auth-token"));
    setCustomerDetails(
      JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details")),
    );
  }, []);

  useEffect(() => {
    const handleMessage = (message) => {
      console.log("message", message);
      if (!message || !message.room) return;

      // Update conversations
      setConversations((prevConversations) =>
        prevConversations.map((conversation) =>
          conversation.roomId === message.room
            ? {
                ...conversation,
                messages: [...conversation.messages, message],
              }
            : conversation,
        ),
      );

      // Update Redux convo and localStorage session if message belongs to active live chat room
      const activeSession = getValidChatSession(props.uniquePartnerId);
      const isLiveChatRoom =
        message.room === convo?.roomId ||
        message.room === activeSession?.roomId ||
        message.room === activeSession?.conversation?.roomId;

      if (isLiveChatRoom) {
        dispatch(updateMessage(message));
        if (activeSession) {
          const existingConvo = activeSession.conversation || {};
          const existingMessages = existingConvo.messages || [];
          const exists = existingMessages.some(
            (m) =>
              (m._id && message._id && m._id === message._id) ||
              (m.localId && message.localId && m.localId === message.localId) ||
              (m.sender === message.sender &&
                (m.message || m.attachment) === (message.message || message.attachment) &&
                Math.abs(new Date(m.timestamp || 0) - new Date(message.timestamp || 0)) < 5000)
          );
          if (!exists) {
            saveChatSession(props.uniquePartnerId, {
              ...activeSession,
              conversation: {
                ...existingConvo,
                messages: [...existingMessages, message],
              },
            });
          }
        }
      }

      if (selectedConversation && message.room === selectedConversation.roomId) {
        setSelectedConversation((prevSelectedConversation) => ({
          ...prevSelectedConversation,
          messages: [...prevSelectedConversation.messages, message],
        }));
      }

      // Show notification for agent messages
      if (message.sender !== "Customer") {
        const rawContent = (message.message || "").trim();
        const msgTime = message.timestamp || message.createdAt || "";
        const dedupeKey =
          message._id ||
          message.clientMessageId ||
          `${message.room}_${message.sender}_${rawContent}_${msgTime}`;

        // Deduplicate: If this message was already processed recently, ignore
        if (processedMessageIdsRef.current.has(dedupeKey)) {
          console.log("Duplicate socket message prevented:", dedupeKey);
          return;
        }
        processedMessageIdsRef.current.add(dedupeKey);
        setTimeout(() => {
          processedMessageIdsRef.current.delete(dedupeKey);
        }, 15000);

        // Register known room and mark unread thread for Dexy AI thread list
        if (message.room) {
          addKnownRoom(props.uniquePartnerId, message.room);
          addUnreadThread(props.uniquePartnerId, message.room);
        }

        // Only show message count on Dexy footer ("ai")
        // Any widget chat / bot / agent message routes strictly to "ai"
        const isEmailTicket = conversations.some((c) => c.roomId === message.room && c.source !== "widget");
        const targetTab = isEmailTicket ? "tickets" : "ai";

        const chatSession = getValidChatSession(props.uniquePartnerId);
        const dexySession = getValidDexySession(props.uniquePartnerId);
        const currentChatRoom = convo?.roomId || chatSession?.roomId;
        const isCurrentBotRoom = !message.room || message.room === currentChatRoom || message.room === (dexySession?.roomId || selectedDexyRoomId);

        const isActivelyViewing =
          isOpen &&
          ((view === "message" && selectedConversation?.roomId === message.room) ||
            (view === "DexyAI" && (message.room === (dexySession?.roomId || selectedDexyRoomId))) ||
            (view === "AutomatedBot" && isCurrentBotRoom));

        if (!isActivelyViewing) {
          playNotificationSound();

          // Increment specific tab counter
          setTabUnreadCounts((prev) => ({
            ...prev,
            [targetTab]: (prev[targetTab] || 0) + 1,
          }));

          const cleanText = cleanPreviewText(
            message.message ||
              (message.attachments && message.attachments.length > 0
                ? "Sent an attachment"
                : "New message received"),
          );

          let initialSenderName =
            message.senderName ||
            message.agentName ||
            message.user?.name ||
            message.user?.username ||
            (message.fromAddress ? message.fromAddress.split("@")[0] : null) ||
            (message.sender !== "Customer" ? message.sender : "Operator");

          let initialAvatar = message.avatar || message.user?.profilePicture;

          if (message.senderId) {
            const cached = getCachedAgentInfo(message.senderId);
            if (cached) {
              if (cached.name) initialSenderName = cached.name;
              if (cached.avatar) initialAvatar = cached.avatar;
            } else {
              getAgentInfoById(message.senderId).then((agent) => {
                if (agent) {
                  setUnreadNotifications((prev) =>
                    prev.map((notif) =>
                      notif.senderId === message.senderId || notif.id === dedupeKey
                        ? {
                            ...notif,
                            senderName: agent.name,
                            agentName: agent.name,
                            avatar: agent.avatar || notif.avatar,
                          }
                        : notif
                    )
                  );
                }
              });
            }
          }

          const newNotif = {
            id: dedupeKey,
            room: message.room,
            sender: message.sender,
            senderId: message.senderId,
            senderName: initialSenderName,
            agentName: initialSenderName,
            user: message.user,
            avatar: initialAvatar,
            message: message.message,
            cleanText: cleanText,
            timestamp:
              message.timestamp || message.createdAt || new Date().toISOString(),
            targetTab: targetTab,
            rawMessage: message,
          };

          setUnreadNotifications((prev) => {
            const exists = prev.some(
              (n) =>
                n.id === dedupeKey ||
                (n.room === message.room &&
                  n.cleanText === cleanText &&
                  Math.abs(new Date(n.timestamp).getTime() - new Date(newNotif.timestamp).getTime()) < 3000),
            );
            if (exists) return prev;
            return [newNotif, ...prev];
          });

          if (!isOpen) {
            setShowNotificationPopup(true);
          }
        }
      }
    };

    const handleTicketStatusUpdated = (response) => {
      setConversations((prevConversations) =>
        prevConversations.map((conversation) =>
          conversation.roomId === response.roomId
            ? {
                ...conversation,
                ticketId: {
                  ...conversation.ticketId,
                  status: response.status,
                },
              }
            : conversation,
        ),
      );
  
      if (selectedConversation && response.roomId === selectedConversation.roomId) {
        setSelectedConversation((prevSelectedConversation) => ({
          ...prevSelectedConversation,
          ticketId: {
            ...prevSelectedConversation.ticketId,
            status: response.status,
          },
        }));
      }
    };

    const handleNewsPopup = (data) => {
      if (!data || !data.articleId) return;
      if (isPopupDismissed(data.articleId, data.popupConfig)) return;

      const triggerDelay =
        data.popupConfig?.trigger?.timing === "after_delay"
          ? (data.popupConfig?.trigger?.delaySeconds || 5)
          : (data.popupConfig?.pageRules?.timeOnPageSeconds || 0);

      if (triggerDelay > 0) {
        setTimeout(() => {
          setActiveNewsPopup(data);
          kbService.trackPopupInteraction(data.articleId, "impression");
        }, triggerDelay * 1000);
      } else {
        setActiveNewsPopup(data);
        kbService.trackPopupInteraction(data.articleId, "impression");
      }
    };

    const handleSurveyPopup = (surveyData) => {
      if (!surveyData || !surveyData._id) return;
      const shareConfig = surveyData.shareConfig || {};
      const reshowCfg = shareConfig.reshowAfterDismiss;
      const pageRules = shareConfig.pageRules || {};

      if (isSurveyDismissed(surveyData._id, reshowCfg)) return;

      const triggerDelay = pageRules.timeOnPageSeconds || 0;

      if (triggerDelay > 0) {
        setTimeout(() => {
          setActiveSurveyPopup(surveyData);
        }, triggerDelay * 1000);
      } else {
        setActiveSurveyPopup(surveyData);
      }
    };

    socket.on("message", handleMessage);
    socket.on("ticketStatusUpdated", handleTicketStatusUpdated);
    socket.on("news:inapp_popup", handleNewsPopup);
    socket.on("survey:inapp_popup", handleSurveyPopup);
  
    return () => {
      socket.off("message", handleMessage);
      socket.off("ticketStatusUpdated", handleTicketStatusUpdated);
      socket.off("news:inapp_popup", handleNewsPopup);
      socket.off("survey:inapp_popup", handleSurveyPopup);
    };
  }, [selectedConversation, isOpen, view, conversations, convo?.roomId, isPopupDismissed, isSurveyDismissed]);

  useEffect(() => {
    // Ensure socket has the latest partnerId
    if (props.uniquePartnerId) {
      getSocket(token, props.uniquePartnerId);
    }
  }, [props.uniquePartnerId, token]);

  useEffect(() => {
    const handleConnect = () => {
      const dexySession = getValidDexySession(props.uniquePartnerId);
      const chatSession = getValidChatSession(props.uniquePartnerId);
      const known = getKnownRooms(props.uniquePartnerId);
      const roomIds = [
        ...conversations.map((conversation) => conversation.roomId),
        ...(convo?.roomId ? [convo.roomId] : []),
        ...(dexySession?.roomId ? [dexySession.roomId] : []),
        ...(chatSession?.roomId ? [chatSession.roomId] : []),
        ...known,
      ].filter(Boolean);
      const uniqueRooms = Array.from(new Set(roomIds));
      if (uniqueRooms.length > 0) {
        socket.emit("join", uniqueRooms);
      }
    };

    socket.on("connect", handleConnect);

    if (socket.connected) {
      handleConnect();
    }

    return () => {
      socket.off("connect", handleConnect);
    };
  }, [conversations, convo?.roomId, props.uniquePartnerId]);

  useEffect(() => {
    if (attachment && attachmentType) {
      sendMessage();
    }
  }, [attachment, attachmentType]);

  // Add sound notification when chat receives message
  const playNotificationSound = useCallback(() => {
    try {
      const audio = new Audio(notificationSound);
      audio.volume = 0.25;
      audio.play().catch((e) => console.log("Audio notification play note:", e));
    } catch (e) {
      console.log("Audio notification error:", e);
    }
  }, []);


  // Update the sendMessage function
  const sendMessage = async (manualFile = null) => {
    const inputMessage = message.trim();
    let finalAttachments = null;

    // 1. If there is a file, upload it first
    if (manualFile) {
      const uploaded = await uploadFile(manualFile);
      if (uploaded) {
        finalAttachments = [
          {
            url: uploaded.data.url,
            filename: uploaded.data.filename,
            type: uploaded.data.type,
            size: uploaded.data.size,
          },
        ];
      }
    }

    // 2. Emit the message
    if (inputMessage || finalAttachments) {
      const msg = {
        room: selectedConversation.roomId,
        sender: "Customer",
        senderId: customerDetails?._id,
        message: inputMessage || null,
        attachment: finalAttachments ? finalAttachments[0].url : null, // Sending URL instead of Base64
        attachmentType: finalAttachments ? finalAttachments[0].type : null,
        attachments: finalAttachments, // Full metadata
        timestamp: new Date().toISOString(),
      };

      socket.emit("message", msg);
      setMessage("");
      setAttachment(null);
      setAttachmentType(null);
    }
  };



  const [processedAttachments, setProcessedAttachments] = useState([]);

  useEffect(() => {
    const sendAttachments = async () => {
      if (defaultMessagesData?.attachment) {
        for (const attachment of defaultMessagesData.attachments) {
          const attachmentKey = `${attachment.name}-${attachment.size}`;

          if (processedAttachments.includes(attachmentKey)) {
            console.log(
              `Attachment ${attachment.name} already sent, skipping.`,
            );
            continue;
          }

          const reader = new FileReader();

          await new Promise((resolve) => {
            reader.onloadend = async () => {
              setAttachment(reader.result);
              setAttachmentType(attachment.type);
              await sendMessage();
              setProcessedAttachments((prev) => [...prev, attachmentKey]);
              resolve();
            };
            reader.readAsDataURL(attachment);
          });
        }

        setDefaultMessagesData(null);
      }
    };

    sendAttachments();
  }, [defaultMessagesData]);


  const createNewChat = async (formData) => {
    const roomId = `Room-${new Date().getTime()}`;
    const customerId = props.userId || customerDetails?._id;
    const uniquePartnerId = props.uniquePartnerId;
    const owner = null;

    // Get token for authentication
    const token = localStorage.getItem("dexkor-chat-widget-auth-token");

    socket.emit(
      "createRoom",
      uniquePartnerId,
      roomId,
      ticketId,
      customerId,
      owner,
      async (response) => {
        if (response.success) {
          setConversations((prevConversations) => [
            ...prevConversations,
            response.conversation,
          ]);

          setSelectedConversation(response.conversation);
          setView("message");
          setDefaultMessagesData(null);

          // 4. PREPARE AND SEND MESSAGE IMMEDIATELY with attachments
          if (formData?.attachments && formData.attachments.length > 0) {
            // Upload attachments first if they exist
            let uploadedAttachments = [];

            // Upload each attachment
            const uploadPromises = formData.attachments.map(async (file) => {
              const fileFormData = new FormData();
              fileFormData.append('attachment', file);

              try {
                const res = await fetch(`${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/attachment`, {
                  method: 'POST',
                  body: fileFormData,
                  headers: {
                    Authorization: `Bearer ${token}` // Add authentication
                  }
                });

                if (!res.ok) throw new Error('File upload failed');
                const result = await res.json();

                return {
                  url: result.data.url,
                  filename: result.data.filename,
                  type: result.data.type,
                  size: result.data.size,
                };
              } catch (error) {
                console.error('Attachment upload failed:', error);
                return null;
              }
            });

            uploadedAttachments = (await Promise.all(uploadPromises)).filter(att => att !== null);

            // Create the message payload with attachments
            const messageData = {
              room: roomId,
              sender: "Customer",
              senderId: customerId,

              message: formData?.description || "",
              attachments: uploadedAttachments,
              attachmentType: uploadedAttachments.length > 0 ? uploadedAttachments[0].type : null,
              timestamp: new Date().toISOString(),
              fromAddress : customerDetails?.email
            };

            console.log('Sending first message with attachments:', messageData);
            socket.emit("message", messageData);
          } else if (formData?.description && formData.description.trim()) {
            // Send message without attachments only if description exists
            const messageData = {
              room: roomId,
              sender: "Customer",
              senderId: customerId,
              message: formData.description.trim(),
              timestamp: new Date().toISOString(),
              fromAddress : customerDetails?.email
            };

            socket.emit("message", messageData);
          }
        }
      }
    );

    setTicketId(null);
  };

  const color1 = setupDetails?.widgetCustomizations?.color1 || setupDetails?.widgetCustomizations?.primaryColor || "#0C2A4D";
  const color2 = setupDetails?.widgetCustomizations?.color2 || setupDetails?.widgetCustomizations?.secondaryColor || "#2060EA";
  const color3 = setupDetails?.widgetCustomizations?.color3 || "#FFFFFF";
  const uiColor = setupDetails?.widgetCustomizations?.uiColor || color1 || "#1C243A";
  const backgroundColor = setupDetails?.widgetCustomizations?.backgroundColor || "#FFFFFF";

  const partnerBrandName =
    setupDetails?.partnerId?.companyName ||
    setupDetails?.companyName ||
    setupDetails?.name ||
    "DexKor";

  const getAgentDisplayName = useCallback((item) => {
    if (!item) return "Operator";
    if (item.senderId) {
      const cached = getCachedAgentInfo(item.senderId);
      if (cached && cached.name) return cached.name;
    }
    return (
      item.senderName ||
      item.agentName ||
      item.user?.name ||
      (item.fromAddress ? item.fromAddress.split("@")[0] : null) ||
      (item.sender && item.sender !== "Customer" ? item.sender : "Operator")
    );
  }, []);

  const formatRelativeTime = useCallback((timestamp) => {
    if (!timestamp) return "Just now";
    const now = new Date();
    const msgTime = new Date(timestamp);
    const diffInSeconds = Math.max(0, Math.floor((now - msgTime) / 1000));
    if (diffInSeconds < 60) return "Just now";
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays}d ago`;
  }, []);

  // Timer to dynamically update relative timestamps ("Just now" -> "1m ago" -> "2m ago")
  const [, setTimeTicker] = useState(0);
  useEffect(() => {
    if (!showNotificationPopup && unreadNotifications.length === 0) return;
    const timer = setInterval(() => {
      setTimeTicker((prev) => prev + 1);
    }, 15000);
    return () => clearInterval(timer);
  }, [showNotificationPopup, unreadNotifications.length]);

  // Resolve agent details for any unreadNotifications loaded from localStorage or props
  useEffect(() => {
    unreadNotifications.forEach((n) => {
      if (n.senderId && !getCachedAgentInfo(n.senderId)) {
        getAgentInfoById(n.senderId).then((agent) => {
          if (agent) {
            setUnreadNotifications((prev) =>
              prev.map((item) =>
                item.senderId === n.senderId
                  ? {
                      ...item,
                      senderName: agent.name,
                      agentName: agent.name,
                      avatar: agent.avatar || item.avatar,
                    }
                  : item
              )
            );
          }
        });
      }
    });
  }, [unreadNotifications]);

  const handleOpenFromNotification = useCallback(
    (notif) => {
      setShowNotificationPopup(false);
      setIsOpen(true);
      setUnreadNotifications([]);

      const targetRoom =
        notif?.room || (unreadNotifications[0] && unreadNotifications[0].room);
      const targetConv = conversations.find((c) => c.roomId === targetRoom);

      if (targetConv && targetConv.source !== "widget") {
        setActiveIcon("tickets");
        setSelectedConversation(targetConv);
        setView("message");
        setTabUnreadCounts((prev) => ({ ...prev, tickets: 0 }));
      } else {
        // Redirect directly to that specific chat thread in Dexy AI
        setActiveIcon("ai");
        setView("DexyAI");
        if (targetRoom) {
          setSelectedDexyRoomId(targetRoom);
          clearUnreadThread(props.uniquePartnerId, targetRoom);
        }
        setTabUnreadCounts((prev) => ({ ...prev, ai: 0, messages: 0 }));
      }
    },
    [conversations, props.uniquePartnerId, unreadNotifications],
  );

  const renderAgentAvatar = (item) => {
    const cached = item?.senderId ? getCachedAgentInfo(item.senderId) : null;
    const avatarUrl = item?.avatar || item?.user?.profilePicture || cached?.avatar;
    const name = getAgentDisplayName(item);
    const initial = cached?.initials || (name ? name.charAt(0).toUpperCase() : "A");

    return (
      <div className="relative flex-shrink-0 w-9 h-9">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={name}
            className="w-9 h-9 rounded-full object-cover border border-slate-200/80 shadow-xs"
            onError={(e) => {
              e.target.style.display = "none";
              if (e.target.nextSibling) {
                e.target.nextSibling.style.display = "flex";
              }
            }}
          />
        ) : null}
        <div
          style={{
            display: avatarUrl ? "none" : "flex",
            background: `linear-gradient(135deg, ${color1 || "#3b82f6"} 0%, ${color2 || "#1d4ed8"} 100%)`,
          }}
          className="w-9 h-9 rounded-full items-center justify-center text-white text-xs font-bold shadow-xs select-none"
        >
          {initial}
        </div>
        <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-500 rounded-full border-2 border-white pointer-events-none" />
      </div>
    );
  };

  const renderNotificationPopup = () => {
    if (isOpen || !showNotificationPopup || unreadNotifications.length === 0) {
      return null;
    }

    const count = unreadNotifications.length;
    const isLeftAligned = setupDetails?.widgetCustomizations?.alignment === "left";

    return (
      <div
        className={`nodrag dexkor-notif-popup ${isLeftAligned ? "align-left" : ""} absolute z-[1000001] select-none`}
        style={{
          bottom: "64px",
          [isLeftAligned ? "left" : "right"]: "0px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative bg-white rounded-2xl shadow-[0_12px_36px_rgba(0,0,0,0.15),0_2px_8px_rgba(0,0,0,0.06)] border border-slate-100 overflow-hidden w-[320px] sm:w-[350px]">
          {/* CASE 1: Single Message */}
          {count === 1 && (() => {
            const notif = unreadNotifications[0];
            return (
              <div
                onClick={() => handleOpenFromNotification(notif)}
                className="p-4 cursor-pointer hover:bg-slate-50/50 transition-colors"
              >
                <div className="flex items-start gap-3">
                  {renderAgentAvatar(notif)}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-1">
                      <div className="truncate">
                        <span className="font-semibold text-slate-800 text-[13px]">
                          {getAgentDisplayName(notif)}
                        </span>
                        <span className="text-slate-400 font-normal text-[11px] ml-1.5">
                          from {partnerBrandName}
                        </span>
                      </div>
                      <div className="flex items-center gap-1.5 flex-shrink-0">
                        <span className="text-slate-400 text-[11px]">
                          {formatRelativeTime(notif.timestamp)}
                        </span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowNotificationPopup(false);
                          }}
                          className="text-slate-400 hover:text-slate-600 p-0.5 rounded-full hover:bg-slate-100 transition-colors"
                          title="Dismiss"
                        >
                          <X className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    </div>
                    <p className="text-slate-700 text-[13px] leading-relaxed mt-1.5 font-normal line-clamp-3 whitespace-pre-line">
                      {notif.cleanText}
                    </p>
                  </div>
                </div>
              </div>
            );
          })()}

          {/* CASE 2: 2–3 Messages */}
          {(count === 2 || count === 3) && (
            <div>
              <div className="divide-y divide-slate-100">
                {unreadNotifications.slice(0, 3).map((item, idx) => (
                  <div
                    key={item.id || idx}
                    onClick={() => handleOpenFromNotification(item)}
                    className="p-3.5 flex items-start gap-3 hover:bg-slate-50/70 transition-colors cursor-pointer"
                  >
                    {renderAgentAvatar(item)}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between gap-1">
                        <div className="truncate">
                          <span className="font-semibold text-slate-800 text-[13px]">
                            {getAgentDisplayName(item)}
                          </span>
                          <span className="text-slate-400 font-normal text-[11px] ml-1.5">
                            from {partnerBrandName}
                          </span>
                        </div>
                        <div className="flex items-center gap-1.5 flex-shrink-0">
                          <span className="text-slate-400 text-[11px]">
                            {formatRelativeTime(item.timestamp)}
                          </span>
                          {idx === 0 && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowNotificationPopup(false);
                              }}
                              className="text-slate-400 hover:text-slate-600 p-0.5 rounded-full hover:bg-slate-100 transition-colors"
                              title="Dismiss"
                            >
                              <X className="w-3.5 h-3.5" />
                            </button>
                          )}
                        </div>
                      </div>
                      <p className="text-slate-600 text-[12px] leading-snug mt-1 line-clamp-2">
                        {item.cleanText}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer View All Messages */}
              <div
                onClick={() => handleOpenFromNotification(unreadNotifications[0])}
                className="py-2.5 px-4 text-center border-t border-slate-100 text-blue-600 hover:text-blue-700 hover:bg-blue-50/40 text-[12px] font-semibold transition-colors flex items-center justify-center gap-1 cursor-pointer"
              >
                <span>View all messages ({count})</span>
                <ChevronRight className="w-3.5 h-3.5 stroke-[2.5]" />
              </div>
            </div>
          )}

          {/* CASE 3: 4+ Messages */}
          {count >= 4 && (() => {
            const latest = unreadNotifications[0];
            return (
              <div>
                {/* Header with count and close */}
                <div className="px-4 py-2.5 flex items-center justify-between border-b border-slate-100 bg-slate-50/50">
                  <span className="text-blue-600 font-semibold text-[13px]">
                    {count} new messages
                  </span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowNotificationPopup(false);
                    }}
                    className="text-slate-400 hover:text-slate-600 p-0.5 rounded-full hover:bg-slate-200/60 transition-colors"
                    title="Dismiss"
                  >
                    <X className="w-3.5 h-3.5" />
                  </button>
                </div>

                {/* Single latest message preview */}
                <div
                  onClick={() => handleOpenFromNotification(latest)}
                  className="p-3.5 flex items-start gap-3 hover:bg-slate-50/70 transition-colors cursor-pointer"
                >
                  {renderAgentAvatar(latest)}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-1">
                      <div className="truncate">
                        <span className="font-semibold text-slate-800 text-[13px]">
                          {getAgentDisplayName(latest)}
                        </span>
                        <span className="text-slate-400 font-normal text-[11px] ml-1.5">
                          from {partnerBrandName}
                        </span>
                      </div>
                      <span className="text-slate-400 text-[11px] flex-shrink-0">
                        {formatRelativeTime(latest.timestamp)}
                      </span>
                    </div>
                    <p className="text-slate-600 text-[12px] leading-snug mt-1 line-clamp-2">
                      {latest.cleanText}
                    </p>
                  </div>
                </div>

                {/* Footer View All Messages */}
                <div
                  onClick={() => handleOpenFromNotification(latest)}
                  className="py-2.5 px-4 text-center border-t border-slate-100 text-blue-600 hover:text-blue-700 hover:bg-blue-50/40 text-[12px] font-semibold transition-colors flex items-center justify-center gap-1 cursor-pointer"
                >
                  <span>View all messages</span>
                  <ChevronRight className="w-3.5 h-3.5 stroke-[2.5]" />
                </div>
              </div>
            );
          })()}
        </div>

        {/* Downward Pointer Notch pointing at the launcher button */}
        <div
          className="absolute -bottom-1.5 w-3.5 h-3.5 bg-white rotate-45 border-r border-b border-slate-200/80 pointer-events-none"
          style={{
            [isLeftAligned ? "left" : "right"]: "18px",
          }}
        />
      </div>
    );
  };

  const renderNewsPopup = () => {
    if (isOpen || !activeNewsPopup) return null;

    const isLeftAligned = setupDetails?.widgetCustomizations?.alignment === "left";

    return (
      <div
        className={`nodrag dexkor-news-popup absolute z-[1000002] select-none ${isLeftAligned ? "align-left" : ""}`}
        style={{
          bottom: "74px",
          [isLeftAligned ? "left" : "right"]: "0px",
        }}
        onClick={(e) => handleOpenNewsPopup(activeNewsPopup, e)}
      >
        <div className="relative w-[310px] sm:w-[340px] bg-white rounded-2xl shadow-[0_16px_40px_rgba(0,0,0,0.18)] border border-slate-100 overflow-visible cursor-pointer hover:shadow-2xl transition-all duration-300 group">
          {/* Circular Close Button (top-right overlapping corner) */}
          <button
            type="button"
            onClick={(e) => handleDismissNewsPopup(activeNewsPopup.articleId || activeNewsPopup._id, e)}
            className="absolute -top-2.5 -right-2.5 w-7 h-7 bg-white text-slate-500 hover:text-black rounded-full shadow-md border border-slate-200 flex items-center justify-center z-30 cursor-pointer hover:scale-110 transition-transform"
            title="Dismiss"
          >
            <X className="w-3.5 h-3.5 stroke-[2.5]" />
          </button>

          {/* Banner Image */}
          {activeNewsPopup.bannerImage && (
            <div className="w-full h-[145px] sm:h-[160px] overflow-hidden rounded-t-2xl relative bg-slate-900">
              <img
                src={activeNewsPopup.bannerImage}
                alt={activeNewsPopup.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          )}

          {/* Text Content */}
          <div className="p-4 sm:p-4.5 bg-white rounded-b-2xl">
            <h4 className="text-[15px] font-bold text-slate-900 leading-snug line-clamp-2 mb-1 group-hover:text-blue-600 transition-colors">
              {activeNewsPopup.title}
            </h4>
            <p className="text-[12px] text-slate-600 line-clamp-2 leading-relaxed font-normal m-0">
              {activeNewsPopup.description || activeNewsPopup.title}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Top Banner Announcement Bar (Inline or Floating Top Overlay) */}
      {renderBannerPopup()}

      {/* Large Format Survey Modal (Screen Centered Overlay outside Draggable) */}
      {activeSurveyPopup && activeSurveyPopup?.optionsConfig?.format === "large" && !isOpen && (
        <SurveyWidgetModal
          survey={activeSurveyPopup}
          onClose={() => setActiveSurveyPopup(null)}
          onDismiss={(id, cfg) => handleDismissSurvey(id, cfg)}
          userEmail={props?.userEmail || customerDetails?.email || ""}
          userName={props?.userName || customerDetails?.name || ""}
          primaryColor={setupDetails?.widgetCustomizations?.uiColor || setupDetails?.widgetCustomizations?.color2 || "#2563eb"}
          alignment={setupDetails?.widgetCustomizations?.alignment || "right"}
        />
      )}

      {/* 1. THE CHAT PANEL (Floating above the launcher icon) */}
      {isOpen && (
        <div
          className={`dexkor-chat-widget-panel fixed z-[999999] overflow-hidden !rounded-[5px] shadow-[0_24px_60px_-15px_rgba(0,0,0,0.28)] ${
            setupDetails?.widgetCustomizations?.alignment === "left"
              ? "!left-[10px] sm:!left-[24px]"
              : "!right-[10px] sm:!right-[24px]"
          } !bottom-[90px] sm:!bottom-[92px] ${
            isExpanded
              ? "!w-[95%] sm:!w-[580px] md:!w-[720px] !h-[82vh] !max-h-[850px]"
              : "!w-[calc(100%-20px)] sm:!w-[390px] max-w-[420px] !h-[630px] !max-h-[calc(100vh-115px)]"
          }`}
          style={{
            "--dexkor-color-1": color1,
            "--dexkor-color-2": color2,
            "--dexkor-color-3": color3,
            "--dexkor-ui-color": uiColor,
            "--dexkor-bg": backgroundColor,
            "--dexkor-header-gradient": `linear-gradient(180deg, ${color1} 0%, ${color2} 60%, ${color3 || backgroundColor || '#ffffff'} 100%)`,
            backgroundColor: backgroundColor || "#ffffff",
          }}
          data-html2canvas-ignore="true" // This tells the library to skip this element
        >
          <div
            className={`dexkor-chat-widget transition-container open !rounded-[5px] overflow-hidden !h-full !w-full flex flex-col ${isExpanded ? "expanded" : ""
              } non-draggable`}
          >
            {isOpen &&
              view !== "LandingWindow" &&
              view !== "Bot" &&
              view !== "Convo" &&
              view !== "LiveChat" &&
              view !== "Help" &&
              view !== "Roadmap" &&
              view !== "News" &&
              view !== "message" &&
              view !== "DexKorOverview" &&
              view !== "DexKor" &&
              !showTicketForm &&
              view !== "AutomatedBot" && view !== "DexyAI" && (
                <Header
                  setIsOpen={setIsOpen}
                  view={view}
                  setView={setView}
                  setIsExpanded={setIsExpanded}
                  isExpanded={isExpanded}
                  logo={setupDetails?.widgetCustomizations.logoUrl}
                  setupDetails={setupDetails}
                  setActiveIcon={setActiveIcon}
                />
              )}

            <div className={`flex-1 relative min-h-0 w-full flex flex-col ${
              view === "LandingWindow" || view === "Help" || view === "News" || view === "chatList"
                ? "overflow-y-auto overflow-x-hidden"
                : "overflow-hidden"
            }`}>
              <SwitchTransition mode="out-in">
                <CSSTransition
                  key={view}
                  timeout={200}
                  classNames="fade"
                  unmountOnExit
                >
                  {(state) => (
                    <>
                      {view === "LandingWindow" ? (
                        <LandingWindow
                          setView={setView}
                          setupDetails={setupDetails}
                          setIsOpen={setIsOpen}
                          setActiveIcon={setActiveIcon}
                          widgetConfigs={props}
                          setInitialDexyMessage={setInitialDexyMessage}
                          setSelectedArticle={setSelectedArticle}
                          conversations={conversations}
                          setSelectedConversation={setSelectedConversation}
                        />
                      ) : view === "AutomatedBot" ? ( // ✅ Added AutomatedBot view
                        <AutomatedBot
                          initialMessage={initialDexyMessage}
                          onMessageConsumed={() => setInitialDexyMessage("")}
                          setView={setView}
                          setupDetails={setupDetails}
                          widgetConfigs={props}
                          setActiveIcon={setActiveIcon}
                          setIsOpen={setIsOpen}
                          conversations={conversations}
                          fetchConversations={fetchConversations}
                          customerDetails={customerDetails}
                        />
                      ) : view === "Convo" ? (
                        <Convo
                          setView={setView}
                          setActiveIcon={setActiveIcon}
                          setupDetails={setupDetails}
                          setIsOpen={setIsOpen}
                        />
                      ) : view === "LiveChat" ? (
                        <LiveChat
                          setView={setView}
                          setActiveIcon={setActiveIcon}
                        />
                      ) : view === "AIAgentInfo" ? (
                        <AIAgentInfo />
                      ) : view === "MetricsAndAttributes" ? (
                        <MetricsAndAttributes />
                      ) : view === "CDAInfo" ? (
                        <CDAInfo />
                      ) : view === "SupportContent" ? (
                        <SupportContent />
                      ) : view === "Help" ? (
                        <Help
                          setView={setView}
                          setActiveIcon={setActiveIcon}
                          setupDetails={setupDetails}
                          setIsOpen={setIsOpen}
                          isExpanded={isExpanded}
                          setIsExpanded={setIsExpanded}
                          widgetConfigs={props}
                          selectedArticle={selectedArticle}
                          setSelectedArticle={setSelectedArticle}
                        />
                      ) : view === "News" ? (
                        <News
                          setView={setView}
                          setActiveIcon={setActiveIcon}
                          setupDetails={setupDetails}
                          setIsOpen={setIsOpen}
                          isExpanded={isExpanded}
                          setIsExpanded={setIsExpanded}
                          widgetConfigs={props}
                          selectedArticle={selectedArticle}
                          setSelectedArticle={setSelectedArticle}
                        />
                      ) : view === "Roadmap" ? (
                        <Roadmap
                          setView={setView}
                          setActiveIcon={setActiveIcon}
                          setupDetails={setupDetails}
                          setIsOpen={setIsOpen}
                          widgetConfigs={props}
                        />
                      ) : view === "DexKorOverview" ? (
                        <DexKorOverview
                          setView={setView}
                          setupDetails={setupDetails}
                          setIsOpen={setIsOpen}
                          isExpanded={isExpanded}
                          setIsExpanded={setIsExpanded}
                        />
                      ) : view === "DexKor" ? (
                        <DexKor
                          setView={setView}
                          setupDetails={setupDetails}
                          setIsOpen={setIsOpen}
                          isExpanded={isExpanded}
                          setIsExpanded={setIsExpanded}
                        />
                      ) : view === "MessageDetails" ? (
                        <MessageDetails
                          selectedConversation={selectedConversation}
                          goBack={() => setView("chatList")}
                          setView={setView}
                          setupDetails={setupDetails}
                          message={message}
                        />
                      ) : view === "DexyAI" ? (
                          <DexyAi 
                            setView={setView} 
                            setupDetails={setupDetails}
                            widgetConfigs={props}
                            setActiveIcon={setActiveIcon}
                            setIsOpen={setIsOpen}
                            initialMessage={initialDexyMessage}
                            onMessageConsumed={() => setInitialDexyMessage("")}
                            targetRoomId={selectedDexyRoomId}
                            onRoomConsumed={() => setSelectedDexyRoomId(null)}
                            conversations={conversations}
                            fetchConversations={fetchConversations}
                            customerDetails={customerDetails}
                          />): (
                        <>
                          {token === null && view === "chatList" && (
                            <Auth
                              isOpen={isOpen}
                              setToken={setToken}
                              setCustomerDetails={setCustomerDetails}
                              setupDetails={setupDetails}
                              setView={setView}
                              setActiveIcon={setActiveIcon}
                              widgetConfigs={props}
                            />
                          )}
                          {token !== null && (
                            <>
                              {view === "chatList" ? (
                                <ChatList
                                  setTicketId={setTicketId}
                                  ticketId={ticketId}
                                  setSelectedConversation={
                                    setSelectedConversation
                                  }
                                  setView={setView}
                                  createNewChat={createNewChat}
                                  conversations={conversations}
                                  isExpanded={isExpanded}
                                  setIsExpanded={setIsExpanded}
                                  setIsOpen={setIsOpen}
                                  showTicketForm={showTicketForm}
                                  setShowTicketForm={setShowTicketForm}
                                  loading={loading}
                                  setLoading={setLoading}
                                  widgetConfigs={props}
                                  setupDetails={setupDetails}
                                />
                              ) : (
                                view === "message" && (
                                  <Message
                                    selectedConversation={selectedConversation}
                                    setSelectedConversation={
                                      setSelectedConversation
                                    }
                                    setConversations={setConversations}
                                    setMessage={setMessage}
                                    message={message}
                                    setAttachment={setAttachment}
                                    setAttachmentType={setAttachmentType}
                                    attachmentType={attachmentType}
                                    isOpen={isOpen}
                                    setIsOpen={setIsOpen}
                                    sendMessage={sendMessage}
                                    goBack={() => {
                                      setView("chatList");
                                      fetchConversations();
                                      console.log("Going back to chat list");
                                    }}
                                    setupDetails={setupDetails}
                                    setView={setView}
                                    widgetConfigs={props}
                                  />
                                )
                              )}
                            </>
                          )}

                        </>
                      )}
                    </>
                  )}
                </CSSTransition>
              </SwitchTransition>
            </div>
            {isOpen &&
              !showTicketForm &&
              view !== "DexKorOverview" &&
              view !== "DexKor" &&
              view !== "AIAgentInfo" &&
              view !== "MetricsAndAttributes" &&
              view !== "CDAInfo" &&
              view !== "SupportContent" &&
              view !== "message" &&
              view !== "MessageDetails" &&
              view !== "LiveChat" && (
                <Footer
                  setView={setView}
                  activeIcon={activeIcon}
                  setActiveIcon={setActiveIcon}
                  setupDetails={setupDetails}
                  view={view}
                  widgetConfigs={props}
                  setIsExpanded={setIsExpanded}
                  setSelectedArticle={setSelectedArticle}
                  tabUnreadCounts={tabUnreadCounts}
                  setTabUnreadCounts={setTabUnreadCounts}
                />
              )}
          </div>
        </div>
      )}
      {/* 2. THE DRAGGABLE BUTTON (Floating on the left/right) */}
      <Draggable
        position={position}
        onStart={handleStart}
        onStop={handleStop}
        bounds="parent"
        cancel=".nodrag"
      >
        <div
          className="dexkor-draggable-trigger"
          style={{
            position: "fixed",
            [setupDetails?.widgetCustomizations?.alignment === "left"
              ? "left"
              : "right"]: "24px",
            bottom: "24px",
            zIndex: 1000000,
            cursor: "pointer",
          }}
        >
          {/* Floating In-App News Popup Card (Gleap style) */}
          {renderNewsPopup()}

          {/* Floating In-App Chat Message Popup Bubble */}
          {renderChatMessagePopup()}

          {/* Small Format Survey Modal (Floating Near Launcher) */}
          {activeSurveyPopup && activeSurveyPopup?.optionsConfig?.format !== "large" && !isOpen && (
            <SurveyWidgetModal
              survey={activeSurveyPopup}
              onClose={() => setActiveSurveyPopup(null)}
              onDismiss={(id, cfg) => handleDismissSurvey(id, cfg)}
              userEmail={props?.userEmail || customerDetails?.email || ""}
              userName={props?.userName || customerDetails?.name || ""}
              primaryColor={setupDetails?.widgetCustomizations?.uiColor || setupDetails?.widgetCustomizations?.color2 || "#2563eb"}
              alignment={setupDetails?.widgetCustomizations?.alignment || "right"}
            />
          )}

          {/* Floating Message Notification Card Preview (when no news, survey, or chat message popup) */}
          {!activeNewsPopup && !activeSurveyPopup && !activeChatMessagePopup && renderNotificationPopup()}

          {!hideLauncher && (
          <div
            className={`dexkor-chat-toggle-icon ${isOpen ? "is-open" : "is-closed"}`}
            onClick={handleLauncherClick}
            style={{
              background: `linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`,
            }}
            title={isOpen ? "Close chat" : "Open chat"}
          >
            <div className="dexkor-chat-launcher-icon-inner">
              <MessageSquare
                className={`dexkor-chat-icon-svg text-white fill-white ${!isOpen ? "visible" : "hidden"}`}
              />
              <ChevronDownIcon
                className={`dexkor-chat-icon-svg text-white ${isOpen ? "visible" : "hidden"}`}
              />
            </div>

            {/* Red Unread Notification Badge */}
            {!isOpen && (activeNewsPopup || activeSurveyPopup || activeChatMessagePopup || activeBannerPopup || unreadNotifications.length > 0 || (tabUnreadCounts.tickets + tabUnreadCounts.messages + tabUnreadCounts.ai) > 0) && (
              <span className="dexkor-unread-badge absolute -top-1.5 -right-1.5 min-w-[20px] h-[20px] px-1 bg-[#ef4444] text-white text-[11px] font-bold rounded-full flex items-center justify-center border-2 border-white shadow-md z-10 pointer-events-none">
                {(() => {
                  const baseCount = (unreadNotifications.length || 0) + (tabUnreadCounts.tickets + tabUnreadCounts.messages + tabUnreadCounts.ai);
                  const total = (activeNewsPopup || activeSurveyPopup || activeChatMessagePopup || activeBannerPopup) ? baseCount + 1 : baseCount;
                  return total > 3 ? "4+" : total;
                })()}
              </span>
            )}
          </div>
          )}
        </div>
      </Draggable>
    </>
  );
};

export default ChatWindow;
